import { render, staticRenderFns } from "./MockupGeneratorDialog.vue?vue&type=template&id=4c8696e9&scoped=true"
import script from "./MockupGeneratorDialog.vue?vue&type=script&lang=js"
export * from "./MockupGeneratorDialog.vue?vue&type=script&lang=js"
import style0 from "./MockupGeneratorDialog.vue?vue&type=style&index=0&id=4c8696e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8696e9",
  null
  
)

export default component.exports